function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_443",
  "data-name": "Group 443",
  transform: "translate(-52.694 -222.186)"
}, React.createElement("g", {
  id: "document-drafting",
  transform: "translate(52.694 222.186)"
}, React.createElement("path", {
  id: "Path_348",
  "data-name": "Path 348",
  d: "M13.551,1H4.23A2.31,2.31,0,0,0,1.9,3.4V22.6A2.31,2.31,0,0,0,4.23,25H18.211a2.31,2.31,0,0,0,2.33-2.4V8.2ZM12.33,9.457V2.829l6.436,6.629Z",
  transform: "translate(-1.9 -1)",
  fill: "#fff"
})), React.createElement("path", {
  id: "Path_669",
  "data-name": "Path 669",
  d: "M103.251,98.862h3.7v-3.7h2.47l-4.317-4.317-4.318,4.317h2.461ZM100.79,100.1h8.635v1.243H100.79Z",
  transform: "translate(-43.5 141.5)",
  fill: "#82b5e2"
}), React.createElement("g", {
  id: "sign",
  transform: "translate(63 235)"
}, React.createElement("path", {
  id: "Path_687",
  "data-name": "Path 687",
  d: "M4.125,5.852c.514-.521,1.028-.99,1.255-.894.367.147,0,.755-.22,1.114-.184.308-2.1,2.852-2.1,4.626a2.629,2.629,0,0,0,.984,2.185,2.2,2.2,0,0,0,1.938.337c.785-.227,1.431-1.026,2.246-2.031.888-1.092,2.077-2.522,3-2.522,1.2,0,1.211.74,1.292,1.312a4.483,4.483,0,0,0-3.949,3.937,2.317,2.317,0,0,0,2.356,2.265c1.2,0,3.149-.975,3.443-4.472h1.806V9.877H14.358A3.042,3.042,0,0,0,11.4,6.8,5.288,5.288,0,0,0,7.773,8.88c-.426.535-1.512,1.818-1.681,1.994-.184.22-.5.616-.815.616s-.529-.609-.264-1.408A13.373,13.373,0,0,1,6.371,7.5a3.881,3.881,0,0,0,.954-2.4A1.933,1.933,0,0,0,5.483,3a3.2,3.2,0,0,0-2,.916C3.222,4.18,3,4.4,2.84,4.6Zm6.82,8.549a.551.551,0,0,1-.543-.528,2.6,2.6,0,0,1,2.107-2.024C12.288,13.822,11.458,14.4,10.944,14.4Z",
  transform: "translate(-0.497 -0.525)",
  fill: "#567795"
}), React.createElement("path", {
  id: "Path_688",
  "data-name": "Path 688",
  d: "M0,0H18.148V18.148H0Z",
  fill: "none"
})));

var SvgIconZegalSign = function SvgIconZegalSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 28.454 30.963",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconZegalSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-zegal-sign.60293c37.svg";
export { ForwardRef as ReactComponent };